import { MediaQueryService } from '@workbench/core';

export * from './MediaQueryUtils';

let mqService: MediaQueryService;
export const getMediaQueryService = () => {
  if (!mqService) {
    mqService = new MediaQueryService(window);
  }
  return mqService;
};
